import React from 'react'

import {
  Box, LinearProgress, Typography,
} from '@mui/material'

import { Props } from './types'

function ResultsProgressBar({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  color, value = 0, hasLabel = false, width = {
    xs: '100%',
    sm: '100%',
    md: '100%',
    lg: '100%',
    xl: '100%',
  },
}: Props): React.ReactElement {
  let barColor

  switch (color) {
    case 'green': {
      barColor = '#33A544'
      break
    }
    case 'blue': {
      barColor = '#23B5E8'
      break
    }
    case 'orange': {
      barColor = '#FAA41A'
      break
    }
    default: {
      barColor = '#626262'
      break
    }
  }

  return (
    <Box
      width={width}
      color={barColor}
      display='flex'
      alignItems='center'
    >
      <Box flex={1}>
        <LinearProgress
          color='inherit'
          variant='determinate'
          value={value}
          sx={{
            padding: '16px',
            borderRadius: 0,
          }}
        />
      </Box>
      {hasLabel
      && <Typography ml={1} variant='subtitle1' color='text.secondary'>{value}%</Typography>}
    </Box>
  )
}

export default React.memo(ResultsProgressBar)
